import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import AddItemFormContainer from '../../app-main/components/reduxForms/forms/AddItemForm/AddItemFormContainer';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class EditBookingAddOnModal extends Component {
  render () {
    const {
      toggleModal,
      currency,
      getInventoryItem,
      editBookingAddOn,
      openEditBookingAddOnModal,
      iosWebView,
      whichModal
    } = this.props;

    return (
      <div>
        {
          iosWebView && ('editBookingAddOnModal' === whichModal) ?
            <div className="edit-item-form-ios">
              <div>
                <span className="pull-right ico ico-sm icon-close-sidebar" onClick={toggleModal} />
                <h3>
                  <FormattedMessage
                    id='inbox.edit_booking_add_on_modal.edit_item'
                    defaultMessage='Edit Item'
                  />
                </h3>
              </div>

              <AddItemFormContainer
                toggleModal={toggleModal}
                currency={currency}
                getInventoryItem={getInventoryItem}
                openEditBookingAddOnModal={openEditBookingAddOnModal}
                isEditModal
              />

              <CTAButton
                buttonText={ this.props.intl.formatMessage({ id: 'inbox.edit_booking_add_on_modal.save', defaultMessage: 'Save' }) }
                onClickAction={editBookingAddOn}
                classNameString="btn btn-primary form"
                isDisabled={ false }
                attributes={{ 'data-testing-id': 'add-item-button' }}
              />
            </div>
            :
            <BootstrapModal
              {...this.props}
              modalSize="lg-size"
              modalClass="add-item-modal"
              header={ <h3><FormattedMessage id='inbox.edit_booking_add_on_modal.edit_item_modal' defaultMessage='Edit item'/></h3> }
              body={
                <AddItemFormContainer
                  toggleModal={toggleModal}
                  currency={currency}
                  getInventoryItem={getInventoryItem}
                  openEditBookingAddOnModal={openEditBookingAddOnModal}
                  isEditModal
                />
              }
              footer={
                <CTAButton
                  buttonText={ this.props.intl.formatMessage({ id: 'inbox.edit_booking_add_on_modal.save_footer', defaultMessage: 'Save' }) }
                  onClickAction={editBookingAddOn}
                  classNameString="btn btn-primary form"
                  isDisabled={ false }
                  attributes={{ 'data-testing-id': 'edit-booking-add-on-item-button' }}
                />
              }
            />
        }
      </div>
    );
  }
}

EditBookingAddOnModal.propTypes = {
  addItemId: PropTypes.string,
  toggleModal: PropTypes.func,
  currency: PropTypes.string,
  addItem: PropTypes.func,
  getInventoryItem: PropTypes.func,
  openEditBookingAddOnModal: PropTypes.func,
  whichModal: PropTypes.string,
  editBookingAddOn: PropTypes.func,
  iosWebView: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(EditBookingAddOnModal);
